import Modal from "@/components/Modal"
import React, { useMemo, useState } from "react"
import { Radio } from "@/components/Alpha/View/GalleryFilter"
import IconButton from "@/components/IconButton"
import { usePromptInputStore } from "@/stores"

const SelectPrevTaskPromptModal = () => {
  const { promptInput, setPromptInput } = usePromptInputStore()

  const [tempValue, setTempValue] = useState(0)

  const mappedChains = useMemo(
    () => promptInput?.chains?.filter((chain, idx) => idx < Number(promptInput.index)),
    [promptInput?.chains, promptInput?.index],
  )

  const handleClose = () => {
    setPromptInput(null)
  }

  return (
    <Modal
      title="Select image from previous step"
      isOpen={promptInput?.modalType === "SelectPrevTaskPromptModal"}
      onClose={handleClose}
      bodyClassName="overflow-hidden p-0"
      className="relative w-full max-w-xl  overflow-hidden rounded-2xl bg-atherGray-900"
      containerClassName={"md:backdrop-blur-xl overflow-hidden"}
    >
      <div className="flex flex-col space-y-2">
        {mappedChains?.map((chain, index) => (
          <Radio
            key={index}
            className="w-full"
            name={`Step ${index + 1}: ${chain.recipeName ?? chain.recipeId}`}
            value={index.toString()}
            checked={tempValue === index}
            onChange={v => {
              setTempValue(index)
            }}
          />
        ))}
      </div>
      <div className="flex justify-end items-center space-x-2 mt-6 border-t border-atherGray-800 pt-4">
        <IconButton onClick={handleClose} colorScheme="secondary">
          Cancel
        </IconButton>
        <IconButton
          disabled={tempValue === undefined}
          onClick={() => {
            const value = promptInput?.value

            promptInput?.onChange(`${value ? `${value} ` : value}$$prev.${tempValue}`)
            setTempValue(0)
            handleClose()
          }}
        >
          Add step
        </IconButton>
      </div>
    </Modal>
  )
}

export default SelectPrevTaskPromptModal
